import { useState } from 'react'

import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

import TextInput from '@/components/ui/inputs/TextInput'

type CalendsoPasswordProps = {
  value: string
}

export function CalendsoPassword(props: CalendsoPasswordProps) {
  const { value } = props

  const [showPassword, setShowPassword] = useState<boolean>(false)

  const toggleShowPassword = () => setShowPassword(!showPassword)

  return (
    <TextInput
      readOnly
      type={showPassword ? 'text' : 'password'}
      value={value}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={toggleShowPassword} edge="end" size="small">
              {showPassword ? <VisibilityIcon fontSize="inherit" /> : <VisibilityOffIcon fontSize="inherit" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default CalendsoPassword
